import { memo } from 'react';
import {
  Grid,
  ScrollablePanelContent,
} from '@uniqkey-frontend/shared-app';
import GroupDetailsWidget from './components/GroupDetailsWidget';
import AddUserToGroupWidget from './components/AddUserToGroupWidget';
import { useUser } from '../../../../contexts/UserContext';
import AddOrganizationToGroupWidget from './components/AddOrganizationToGroupWidget';
import { isAdmin } from '../../../../helpers/userRole';
import AddOrganizationForAdminToGroupWidget
  from './components/AddOrganizationForAdminToGroupWidget';

interface IGroupDetailsTabProps {
  groupId: string;
}

const GroupDetailsTab = (props: IGroupDetailsTabProps) => {
  const { groupId } = props;
  const { currentUser } = useUser();
  const { role } = currentUser ?? {};

  return (
    <ScrollablePanelContent p={3} pt={1}>
      <Grid container spacing={2}>
        <Grid container item xs={6} rowGap={3}>
          <GroupDetailsWidget groupId={groupId} />
          <AddUserToGroupWidget groupId={groupId} />
        </Grid>
        <Grid item xs={6}>
          {isAdmin(role)
            ? <AddOrganizationForAdminToGroupWidget groupId={groupId} />
            : <AddOrganizationToGroupWidget groupId={groupId} />}
        </Grid>
      </Grid>
    </ScrollablePanelContent>
  );
};

export default memo(GroupDetailsTab);
